import { DatePipe } from "@angular/common";
import { Component, OnInit, HostListener } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from "src/app/constantes/permissao.constants";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { InadimplenciaTecnica, SITUACAO_INADIMPLENCIA, TIPOS_BLOQUEIO } from "src/app/model/inadimplencia-tecnica.model";
import { PermissaoService } from "src/app/shared/permissao.service";
import { InadimplenciaService } from "../inadimplencia.service";
import { ExportService } from '../../../shared/services/export.service';
import { MensagemService } from "../../mensagem.service";

@Component({
    selector: 'app-inadimplencia-pesquisa',
    templateUrl: './inadimplencia-pesquisa.component.html',
    standalone: false
})
export class InadimplenciaPesquisaComponent implements OnInit{

    public  pesquisado:boolean = false;
    private cnpjUsuario: string;
    public  pesquisaForm:UntypedFormGroup;
    private opcoesPaginacao: number[];
    private inadimplencias:InadimplenciaTecnica[]=[];
    private agentesFinanceiros:AgenteFinanceiro[]=[];
    private atributosPaginacaoComponenteListagem: EntityPagedResult<InadimplenciaTecnica>;
    private podeCadastrarInadimplencia: boolean = true;
    public tiposBloqueio = TIPOS_BLOQUEIO;
    public situacao = SITUACAO_INADIMPLENCIA;

    constructor(
        private datePipe:DatePipe,
        private formBuilder:UntypedFormBuilder,
        private activatedRoute:ActivatedRoute,
        private bnLoadingService:BnLoadingService,
        private bnUsuarioService:BnUsuarioService,
        private permissaoService: PermissaoService,
        private inadimplenciaService:InadimplenciaService,
        private loadingService: BnLoadingService,
        private exportService: ExportService,
        private mensagemServico: MensagemService,
        ){

        this.pesquisaForm = this.formBuilder.group({
            idAgenteFinanceiro:null,
            dataCriacaoInicial:null,
            dataCriacaoFinal:null,
            dataDesativacaoInicial:null,
            dataDesativacaoFinal:null,
            motivo:null,
            tipoBloqueio:null,
            situacao:null,
        });

        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
    }

    @HostListener('window:keydown.enter', ['$event'])
    keyEvent(event: KeyboardEvent) {
      this.buscar();
    }


    ngOnInit(): void {

        this.opcoesPaginacao = [10, 15, 20];
        this.atributosPaginacaoComponenteListagem = {
          page: 1,
          pageSize: this.opcoesPaginacao[0],
          pages: undefined,
          count: undefined,
          list: undefined
        };

        this.permissaoService.getPermissoesUsuarioAutenticado()
        .subscribe((resp: any) => {
          this.podeCadastrarInadimplencia = resp && resp[ROLE_GESTOR_ENVIO];
          if (resp && (resp[ROLE_GESTOR_CONSULTA] || resp[ROLE_GESTOR_ENVIO])) {
            this.construirFormulario();
          }
          else {
            this.pesquisaForm.get("idAgenteFinanceiro").disable();
            this.bnUsuarioService.usuario$.subscribe(usuario => {
              if (usuario) {
                  this.cnpjUsuario = usuario.cnpj;
                  this.construirFormulario(usuario.cnpj);
              }
            });
          }
        });
    }

    private construirFormulario(cnpj?: string) {

        const valoresPesquisaForm = JSON?.parse(sessionStorage.getItem('valoresPesquisaInadimplenciaForm'));

        let agenteDefault = this.retornaAgenteFinanceiro(cnpj);

        if (valoresPesquisaForm) {

            if(valoresPesquisaForm.tipoBloqueio === undefined) {
                valoresPesquisaForm.tipoBloqueio = null;
            }

          this.pesquisaForm.setValue({
            idAgenteFinanceiro: agenteDefault,
            dataCriacaoInicial: valoresPesquisaForm.dataCriacaoInicial,
            dataCriacaoFinal: valoresPesquisaForm.dataCriacaoFinal,
            dataDesativacaoInicial: valoresPesquisaForm.dataDesativacaoInicial,
            dataDesativacaoFinal: valoresPesquisaForm.dataDesativacaoFinal,
            motivo: valoresPesquisaForm.motivo,
            tipoBloqueio: valoresPesquisaForm.tipoBloqueio,
            situacao: valoresPesquisaForm.situacao
          });

        }
        else {
            this.pesquisaForm.get("idAgenteFinanceiro").setValue(agenteDefault || null);
        }

        this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
            sessionStorage.setItem('valoresPesquisaInadimplenciaForm', JSON.stringify(novosValores));
        });
    }

    mudancaPagina(novaPagina: EntityPagedResult<InadimplenciaTecnica>) {
        this.atributosPaginacaoComponenteListagem = novaPagina;
        this.buscar();
    }

    retornaAgenteFinanceiro(cnpj:string){
        return cnpj ? this.agentesFinanceiros
                          .filter( agente => agente.cnpj==cnpj)[0] : null;
    }

    limpar() {
        this.pesquisado = false;
        if (this.cnpjUsuario) {
            const idAgenteFinanceiro = this.retornaAgenteFinanceiro(this.cnpjUsuario);
            this.pesquisaForm.reset({
                idAgenteFinanceiro: idAgenteFinanceiro,
            });
        }
        else { this.pesquisaForm.reset(); }
        this.inadimplencias = [];
    }

    buscar(){
        this.bnLoadingService.bloqueiaTela();
        const dadosPreenchidos = this.tratarInformacoesPreenchidas();
        dadosPreenchidos.pagina = this.atributosPaginacaoComponenteListagem.page;
        dadosPreenchidos.limite = this.atributosPaginacaoComponenteListagem.pageSize;

        this.inadimplenciaService
            .getInadimplenciasTecnicas(dadosPreenchidos)
            .subscribe (response => {
                this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
                this.inadimplencias = response.resultados;
                this.bnLoadingService.liberaTela();
            });
    }

    tratarInformacoesPreenchidas(){

        let dadosPreenchidos:any = {};
        const form = this.pesquisaForm.value;
        if(form.idAgenteFinanceiro)
            dadosPreenchidos.idAgenteFinanceiro = form.idAgenteFinanceiro;
        if(form.dataCriacaoInicial)
            dadosPreenchidos.dataCriacaoInicial = this.datePipe.transform(form.dataCriacaoInicial, 'yyyyMMdd');
        if(form.dataCriacaoFinal)
            dadosPreenchidos.dataCriacaoFinal = this.datePipe.transform(form.dataCriacaoFinal, 'yyyyMMdd');
        if(form.dataDesativacaoInicial)
            dadosPreenchidos.dataDesativacaoInicial = this.datePipe.transform(form.dataDesativacaoInicial, 'yyyyMMdd');
        if(form.dataDesativacaoFinal)
            dadosPreenchidos.dataDesativacaoFinal = this.datePipe.transform(dadosPreenchidos.dataDesativacaoFinal, 'yyyyMMdd');
        dadosPreenchidos.motivo = dadosPreenchidos.motivo?.trim() || '';

        if(form.tipoBloqueio)
            dadosPreenchidos.tipoBloqueio = form.tipoBloqueio;

        if(form.situacao)
            dadosPreenchidos.situacao = form.situacao;

        return dadosPreenchidos;
    }

    exportarInadimplementos() {
        this.loadingService.bloqueiaTela();
        const dadosPreenchidos = this.tratarInformacoesPreenchidas();
        this.inadimplenciaService.getInadimplenciasTecnicas(dadosPreenchidos).subscribe((resp) => {
          this.exportService.exportarInadimplementos(resp);
        });
    }

    excluirInadimplemento(id: number) {
        if (id) {
            this.bnLoadingService.bloqueiaTela();
            this.inadimplenciaService.excluir(id).subscribe(({
                next: () => {
                    this.bnLoadingService.liberaTela();
                    this.mensagemServico.adicionarMensagemSucesso('Inadimplemento excluído com sucesso.');
                    this.buscar();
                },
                error: () => {
                    this.bnLoadingService.liberaTela();
                    this.mensagemServico.adicionarMensagemErro('Erro ao excluir inadimplemento.');
                }
            }))
        }
    }

}
